import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';
import {
  queryElements,
  getFirstElement,
  getHtmlFragmentFromContent,
  replaceWithElement
} from '@/app/shared/utils/content-utils';
import { AdmonitionContent, AdmonitionState } from './admonition-interfaces';
import * as Api from "@/app/interaction/api";
import { createInteractionComponent } from '@/app/interaction/ui'


@injectable()
export class IncludeAdmonitionHandler implements Api.IncludeComponentsHandlerInterface {

  private readonly cssClassTypeMappings: { [cssClass: string]: string } = {
    'admonition--note': 'admonition_types.note',
    'admonition--tip': 'admonition_types.tip',
    'admonition--important': 'admonition_types.important',
    'admonition--caution': 'admonition_types.caution',
    'admonition--warning': 'admonition_types.warning',
    'term': 'course.term'
  };

  public async includeComponents($parsedContent: any): Promise<Vue[]> {

    const admonitions = this.includeComponentsInternal($parsedContent, 'admonition');
    const terms = this.includeComponentsInternal($parsedContent, 'term');

    return [ ...admonitions, ...terms ]
  }

  private includeComponentsInternal($parsedContent: any, cssClass: string) {
    const elements: any = queryElements(`.${cssClass}.component`, $parsedContent);
    if (elements === null) {
      return [];
    }

    let components: Vue[] = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element, cssClass);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any, cssClass: string): Vue {
    const revealCssClass: string = `${cssClass}--reveal`;

    const id: string = $element.attr('id');
    const cssClasses: string = $element.attr('class');
    const label: TranslateResult = this.getLabelByCssClass($element);
    const $titleElement: any = getFirstElement(`.${cssClass}__title`, $element);
    const title: string|null = $titleElement !== null ? $titleElement.text() : null;
    const content: string|null = getHtmlFragmentFromContent(`.${cssClass}__content`, $element);
    const isReveal: boolean = $element.hasClass(revealCssClass);

    const interactionComponent = createInteractionComponent<AdmonitionContent, AdmonitionState>(id, 'admonition', {
      title,
      instruction: null
    }, {
      cssClasses, label, content, isReveal 
    })
    interactionComponent.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
    // const component = this.interactiveComponentFactory(
    //   'admonition', 
    //   { 
    //     result: null, 
    //     state: null, 
    //     props: {
    //       id, cssClasses, label, title, content, isReveal 
    //     }
    //   }
    // )
    // component.$mount();

    // replaceWithElement(`#${id}`, component.$el);

    // return component
  }

  private getLabelByCssClass($element: any): TranslateResult {
    for (const [cssClass, langKey] of Object.entries(this.cssClassTypeMappings)) {
      if ($element.hasClass(cssClass)) {
        return i18n.t(langKey);
      }
    }

    throw new Error('No admonition type found in css classes.');
  }
}
